export default __webpack_public_path__ + "static/media/undp.c3f633f9.png";